module.exports = __webpack_public_path__ + "static/media/iOS.ab2dc878.png";